interface GetPaymentLinkProps {
  msPurchase: string;
  searchParams: URLSearchParams;
  endpoint: 'cgPayment' | 'savePurchasePreferences' | 'okCoupon' | 'changePlan' | 'setupDonation';
}

export default function getPurchaseServiceLink({
  endpoint,
  msPurchase,
  searchParams,
}: GetPaymentLinkProps) {
  if (!msPurchase) {
    throw new Error('A URL for the purchase microservice is required');
  }

  return `${msPurchase}/${endpoint}?${searchParams.toString()}`;
}
